<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-close-button="false"
    :show-title="true"
    :width="'80%'"
    :height="700"
    :title="getTitle.primary"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-work-order-material-info',
    }"
    ref="gc-popup"
  >
    <DxToolbarItem
      v-if="getTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'>- ${getTitle.secondary}</span>`"
    ></DxToolbarItem>
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
    />

    <div class="css-v2 gc-popup-form">
      <gc-form
        :key="1"
        :form-options="{
          gcLabelLocation: 'left',
        }"
        ref="gc-header-form"
        :form-items="getHeaderFormItems"
        :is-normal="true"
        :data-model="getFormModel"
        :form-mode="'review'"
        :from-from="'gc-header-form-d-a'"
        :form-height="popupConfig.height - 85"
      />

      <div class="data-grid">
        <dx-data-grid
          v-if="getVisible"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          :columns="getColumns"
          :data-source="getDataSourceConfig"
          :row-alternation-enabled="true"
          :height="getGridHeight"
          :width="'100%'"
          :ref="'material-info-list-grid'"
          @content-ready="onContentReady"
        >
          <DxScrolling
            :mode="'virtual'"
            :row-rendering-mode="'virtual'"
            :preload-enabled="true"
          />
          <DxSearchPanel :visible="false" />

          <template #material-template="{ data }">
            <div>
              <a @click="onHyperLinkClicked(data)">{{ data.text }}</a>
            </div>
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>

          <template #Status="{ data }">
            <GcStatusChip
              :status="data.data[data.column.dataField]"
              v-if="data.data[data.column.dataField]"
            />
          </template>
        </dx-data-grid>

        <GcFooter v-if="showFooter">
          <template #rightContent>
            <div
              class="gc-grid-footer-item"
              v-for="item in footerRightItems"
              :key="item.label"
            >
              <label class="gc-footer-label">{{ item.label }}</label>
              <GcFooterItem
                :value="item.value"
                :format="item.format"
                :length="item.format == 'Decimal-16-4C' ? 8 : 6"
              />
            </div>
          </template>
        </GcFooter>
      </div>

      <GcPopupMaterialIssue
        :popupConfig="materialPopupInfo"
        :on-hide="onInfoPopupHide"
        v-if="materialPopupInfo.isPopupShow"
        :showLoading="showLoading"
        :popup-mode="materialPopupInfo.popupMode"
        @onRefreshDataList="onRefreshDataList"
      />
    </div>
  </DxPopup>
</template>

<script>
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { WorkOrderService } from "../../_services/api/production/work-order.service";
import { FeatureStorage } from "../../_services/storage";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import dataGridMixin from "../../_mixins/data-grid.mixin";
import GcPopupMaterialIssue from "./gc-popup-material-issue .vue";
import { MaterialIssuesService } from "../../_services/api/production/material-issues.service";
import { getSortSettingsFromCombinedSetting } from "../../_helpers/views/work-order";

export default {
  mixins: [dataGridMixin],
  components: { GcPopupMaterialIssue },
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    onHide: {
      type: Function,
      default: () => [],
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      model: {},
      reversalInitiated: false,
      WorkOrderInstance: "Core",
      materialPopupInfo: {
        isPopupShow: false,
        dataModel: {},
        popupMode: "review", // or 'view' based on the context
      },
      showFooter: false,
    };
  },
  async created() {
    this.reversalInitiated = false;
    await this.loadWorkOrderInstance();

    const MaterialIssueDetailBreakdownDefaultSortColumns =
      await getSortSettingsFromCombinedSetting(
        "MaterialIssueDetailBreakdownDefaultSortColumns",
        this.getColumns.map((col) => col.dataField)
      );

    if (MaterialIssueDetailBreakdownDefaultSortColumns.length > 0) {
      MaterialIssueDetailBreakdownDefaultSortColumns.forEach((element) => {
        const targetCol = this.getColumns.find(
          (col) => col.dataField === element.dataField
        );

        if (targetCol) {
          targetCol.sortOrder = element.sortOrder;
          targetCol.sortIndex = element.sortIndex;
        }
      });

      this.$nextTick(() => {
        const dataGrid = this.$refs["material-info-list-grid"].instance;
        if (dataGrid) {
          dataGrid.option("columns", this.getColumns);
          dataGrid.refresh(true);
        }
      });
    }
  },
  methods: {
    async loadWorkOrderInstance() {
      let workOrderInstanceSetting =
        await SettingsService.getBySettingNameFromDb("WorkOrderInstance");

      if (workOrderInstanceSetting.data.value.length > 0) {
        this.WorkOrderInstance =
          workOrderInstanceSetting.data.value[0].SettingValue;
      }
    },
    onMaterialLevelPopupHide() {
      this.releasePopupInfo.isPopupShow = false;
    },
    onInfoPopupHide() {
      this.materialPopupInfo.isPopupShow = false;
    },
    onPopupHide() {
      this.onHide();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);

      if (this.reversalInitiated) {
        this.reversalInitiated = false;
        this.$emit("onRefreshDataList");
        this.$emit("onRefreshWorkOrderHeader");
      }
    },
    async reverseMaterialIssue(e) {
      this.showLoading(true);
      let lineData = e.row.data;

      try {
        const response = await MaterialIssuesService.reverseMaterialIssue({
          IsAlmondcoMaterialIssue: this.WorkOrderInstance === "Almondco",
          IssueNo: lineData.MaterialIssueCode,
          IssueLineNo: lineData.LineNo,
        });

        if (response) {
          this.onRefreshDataList();
        }

        this.$nextTick(() => {
          this.$notify(
            `Material Issue has been successfully reversed`,
            "success"
          );

          this.getMaterialIssueFooterTotals();
        });
      } catch (error) {
        this.displayServerErrorOnTemplate(
          error,
          "Error reversing material issue"
        );
      } finally {
        this.showLoading(false);
      }
    },
    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },
    onHyperLinkClicked(data) {
      const rowData = data.data;
      this.materialPopupInfo.popupMode = "review";
      this.materialPopupInfo.dataModel = {
        BranchCode: rowData.BranchCode,
        IssueDate: new Date(),
        IssueNo: rowData.MaterialIssueCode,
      };
      this.materialPopupInfo.isPopupShow = true;
    },
    onRefreshDataList() {
      const dataGrid = this.$refs["material-info-list-grid"];
      if (dataGrid && dataGrid.instance) {
        this.reversalInitiated = true;
        dataGrid.instance.refresh();
      }
    },
    onContentReady() {
      this.$nextTick(() => {
        this.showFooter = true;
      });
    },
    async getMaterialIssueFooterTotals() {
      var date = new Date(
        this.popupConfig.dataModel.ReleaseDate
      ).toFilterDateString();
      try {
        const response =
          await MaterialIssuesService.getMaterialIssueFooterTotals(
            `WorkOrderCode=${this.popupConfig.dataModel.WorkOrderCode}&$filter=ProductCode eq '${this.popupConfig.dataModel.ProductCode}' and DateIn eq ${date} and IssueTypeRecordId eq ${this.popupConfig.dataModel.IssueTypeRecordId} and ProcessCode eq '${this.popupConfig.dataModel.ProcessCode}'`
          );

        if (
          response &&
          response.data &&
          response.data.value &&
          response.data.value.length > 0
        ) {
          // Process the response data
          const footerTotals = response.data.value[0];
          this.popupConfig.dataModel = {
            ...this.popupConfig.dataModel,
            ...footerTotals,
          };
        }
      } catch (error) {
        this.displayServerErrorOnTemplate(
          error,
          "Error getting material issue footer totals"
        );
      }
    },
  },
  computed: {
    getGridHeight() {
      return 530;
    },
    getDataSourceConfig() {
      var date = new Date(
        this.popupConfig.dataModel.ReleaseDate
      ).toFilterDateString();

      return WorkOrderService.dataSourceConfig("api/MaterialIssueDetail", {
        filter: `WorkOrderCode eq ${parseInt(
          this.popupConfig.dataModel.WorkOrderCode
        )} and ProductCode eq '${
          this.popupConfig.dataModel.ProductCode
        }' and IssuedDate eq ${date} and IssueTypeRecordId eq ${
          this.popupConfig.dataModel.IssueTypeRecordId
        } and ProcessCode eq '${this.popupConfig.dataModel.ProcessCode}'`,
        select: [
          "BranchDescription",
          "LineNo",
          "StockUM",
          "WorkOrderFriendlyStatus",
        ].concat(this.getSelectFieldsForFilter(this.getColumns)),
      });
    },
    getColumns() {
      return [
        {
          caption: "Issue No",
          dataField: "MaterialIssueCode",
          alignment: "left",
          cellTemplate: "material-template",
          width: 120,
        },
        {
          caption: "Branch",
          dataField: "BranchCode",
          minWidth: ColumnWidth.Branch.minWidth,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.BranchDescription}
                        </span>
                      <span class="record-secondary gc-grid-code">
                        ${info.data.BranchCode}
                      </span>
                    </div>`);
          },
        },
        {
          caption: "Card No",
          dataField: "BinCardNo",
          width: ColumnWidth.CardNo.width,
          maxWidth: ColumnWidth.CardNo.minWidth,
          visible: this.WorkOrderInstance === "Almondco",
        },
        {
          caption: "Season Year",
          dataField: "SeasonYear",
          minWidth: ColumnWidth.Date.minWidth,
          width: ColumnWidth.Date.width,
          visible: this.WorkOrderInstance === "Almondco",
        },
        {
          caption: "Stock UM Qty",
          dataField: "StockUMQty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
        },

        {
          caption: "",
          dataField: "FriendlyStatus",
          cellTemplate: "Status",
          minWidth: ColumnWidth.Status.minWidth,
          width: ColumnWidth.Status.width,
          visible: this.WorkOrderInstance === "Almondco",
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          buttons: [
            {
              hint: "Reversal",
              icon: "repeat",
              visible: (e) => {
                const data = e.row.data;

                if (data && data.WorkOrderFriendlyStatus === "Completed") {
                  return false;
                }

                if (
                  data &&
                  (data.FriendlyStatus === "Issued" ||
                    data.FriendlyStatus === "Returned")
                ) {
                  return true;
                } else {
                  return false;
                }
              },
              onClick: async (e) => {
                let confirmReverse = await this.$confirm(
                  "Are you sure you want to reverse this material issue?",
                  "Reversal Confirmation"
                );

                if (confirmReverse) this.reverseMaterialIssue(e);
              },
            },
          ],
          fixed: true,
          fixedPosition: "right",
          width: 40,
          minWidth: 40,
          visible: this.getUserAccess,
        },
      ];
    },
    getUserAccess() {
      return FeatureStorage.checkPermission("WorkOrderMaterialIssue", "create");
    },
    getFormModel() {
      return this.popupConfig.dataModel;
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              cssClass: "gc-header-form-group",
              items: [
                {
                  label: {
                    text: "Issued Date",
                  },
                  dataField: "ReleaseDate",
                  editorType: "dxDateBox",
                  editorOptions: {
                    displayFormat: "dd MMM yyyy",
                    width: 100,
                  },
                },
                {
                  label: {
                    text: "Work Order",
                  },
                  cssClass: "gc-header-work-order-code",
                  dataField: "WorkOrderCode",
                  editorType: "dxNumberBox",
                  editorOptions: {
                    // width: 100,
                  },
                },
              ],
            },

            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  label: {
                    text: "Planned Product",
                  },
                  dataField: "ProductDisplay",
                  editorType: "dxTextBox",
                },
              ],
            },
          ],
        },
      ];
    },
    getTitle() {
      return {
        primary: this.popupConfig.dataModel.ProductCode,
        secondary: this.popupConfig.dataModel.ProductDescription,
      };
    },
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },

    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            text: "",
            icon: "close",
            stylingMode: "text",
            type: "default",
            onClick: this.onPopupHide,
          },
        },
      ];
    },

    footerItems() {
      return [
        {
          label: "Card Count",
          dataField: "BinCardNo",
          type: "count",
          location: "right",
          format: "Decimal-16-0",
          visible: this.WorkOrderInstance === "Almondco",
          value: this.popupConfig.dataModel.CardCount,
        },
        {
          label: `Total (${this.popupConfig.dataModel.StockUM})`,
          dataField: "StockUMQty",
          type: "sum",
          location: "right",
          format: "Decimal-16-4",
          value: this.popupConfig.dataModel.Issued,
        },
      ];
    },
    footerRightItems() {
      var rightItems = this.footerItems.filter(
        (x) => x.location == "right" && x.visible !== false
      );
      return rightItems;

      // const dataGrid = this.$refs["material-info-list-grid"].instance;
      // const items = dataGrid.getDataSource().items();

      // return rightItems
      //   .map((c) => {
      //     if (c.type === "sum") {
      //       if (c.dataField === "StockUMQty") {
      //         c.label = `Total (${items[0].StockUM})`;
      //       }
      //       c.value = items.reduce((acc, item) => {
      //         return acc + (item[c.dataField] || 0);
      //       }, 0);
      //     } else if (c.type === "count") {
      //       c.value = new Set(
      //         items
      //           .filter(
      //             (item) =>
      //               item.BinCardNo !== undefined &&
      //               item.BinCardNo !== null &&
      //               item.BinCardNo !== 0 &&
      //               item.BinCardNo !== ""
      //           )
      //           .map((item) => {
      //             const bin = item.BinCardNo;
      //             const season =
      //               item.SeasonYear !== undefined &&
      //               item.SeasonYear !== null &&
      //               item.SeasonYear !== 0 &&
      //               item.SeasonYear !== ""
      //                 ? item.SeasonYear
      //                 : "__NO_SEASON__";

      //             return `${bin}_${season}`;
      //           })
      //       ).size;
      //     }

      //     return c;
      //   })
      //   .filter((x) => x != null);
    },
  },
};
</script>

<style lang="scss">
.gc-popup-work-order-material-info {
  .data-grid {
    padding-top: 10px;
  }

  .gc-header-form-group {
    .gc-header-work-order-code {
      padding-left: 40px !important;
    }
  }
}
</style>
